import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { darkGrayFontColor } from '../../styles/colors';
import { BreakPoints, truncateTextStyle } from '../../styles/styles';

const { spacing, common, colors } = THEME;

export const s = StyleSheet.create({
	trigger: {
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: 36,
		width: '100%',
		whiteSpace: 'nowrap',
		borderRadius: common.borderRadius,
		border: common.border,
		backgroundColor: 'transparent',
		padding: `${spacing.sm}px 12px`,
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		cursor: 'pointer',
		':focus': {
			outline: 'none',
			boxShadow: `0 0 0 1px ${colors.primary.main}`,
		},
	},
	item: {
		display: 'flex',
		alignItems: 'center',
		padding: `6px ${spacing.sm}px`,
		cursor: 'pointer',
		fontSize: '0.875rem',
		lineHeight: '1.25rem',
		':hover': {
			backgroundColor: colors.hover.light,
		},
		color: darkGrayFontColor,
	},
	value: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		color: darkGrayFontColor,
	},
	content: {
		minWidth: '100%', // Match trigger width at minimum
		maxWidth: '300px', // Prevent excessive width
		width: 'max-content', // Grow based on content
		maxHeight: 384, // Match Select component max height
		overflowY: 'auto' as const,
	},
	itemsContainer: {
		display: 'flex',
		flexDirection: 'column' as const,
	},
	disclosureIcon: {
		marginLeft: spacing.sm,
		transition: 'transform 150ms ease',
	},
	disclosureIconOpen: {
		transform: 'rotate(180deg)',
	},
	triggerContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
	},
	iconWrapper: {
		width: spacing.md, // Match checkbox size
		height: spacing.md,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	searchBox: {
		background: colors.background.light,
		border: `1px solid ${colors.border.main}`,
		borderRadius: 8,
		boxSizing: 'border-box',
		color: colors.text.light,
		display: 'inline-block',
		fontSize: 14,
		height: 40,
		[BreakPoints.forMaxWidth(950)]: {
			minWidth: 200,
		},
	},
	clearSearch: {
		color: colors.primary.main,
		fontSize: 12,
		cursor: 'pointer',
		background: 'none',
		border: 'none',
		padding: 0,
	},
	searchBoxInput: {
		marginLeft: 10,
		[BreakPoints.forMaxWidth(950)]: {
			width: '70%',
		},
		...truncateTextStyle,
	},
	searchIcon: {
		marginBottom: 2,
		verticalAlign: 'middle',
	},
});
